import {noop} from '@sail/utils';
import {createContext} from 'react';
import Registry from 'src/internal/Registry';

import type {InnerExperiments, InnerFlags} from 'src/types';

type RegistriesContext = {
  experimentsRegistry: Registry<InnerExperiments>;
  flagsRegistry: Registry<InnerFlags>;
};

export default createContext<RegistriesContext>({
  experimentsRegistry: new Registry<InnerExperiments>(noop),
  flagsRegistry: new Registry<InnerFlags>(noop),
});
